Pixlee.module('MosaicApp.Show', function(Show, App, Backbone, Marionette, $) {
    Backbone.Marionette.MultiRegion = Backbone.Marionette.Region.extend({
        open: function(view) {
            this.$el.append(view.el);
        },

        destroy: function() {
            var view = this.currentView;
            if (!view || view.length <= 0) {
                return;
            }

            if (!_.isArray(view)) {
                this.currentView = view = [view];
            }

            _.each(view, function(v) {
                if (v.destroy) {
                    v.destroy();
                }
                this.trigger('view:destroy', v);

                delete v;
            }, this);

            this.currentView = [];

            this.$el.empty();
        },

        append: function(view) {
            this._ensureElement();

            view.render();
            this.open(view);

            if (view.onShow) {
                view.onShow();
            }
            view.trigger('show');

            if (this.onShow) {
                this.onShow(view);
            }
            this.trigger('view:show', view);

            this.currentView = this.currentView || [];

            if (!_.isArray(this.currentView)) {
                this.currentView = [this.currentView];
            }

            this.currentView.push(view);
        }
    });
    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region',
            frame: {
                regionClass: Backbone.Marionette.MultiRegion,
                selector: '.mosaic_frame'
            }
        },
        events: {
            'click .load_more': function() {
                var _this = this;
                this.$el.find('.load_more').addClass('loading');
                this.trigger("loadMore");
                App.commands.execute('load:more', _this.collection.pluck('album_photo_id'), true);
            }
        },
        onShow: function() {
            this.onLoadingOptionsChange();
        },
        onLoadingOptionsChange: function() {
            if (App.displayOptions.get('widget_loadingOption_showHide')) {
                this.$el.find('#mosaic_control').show();
            } else {
                this.$el.find('#mosaic_control').hide();
            }
        },
        onPatchLoadMore: function() {
            this.trigger('loadMore');
        }
    });
    Show.PhotoView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_photo_item.jst.ejs'),
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        initialize: function() {
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                this.on('change:image', this.changeImage, this);
            }
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
        },
        events: {
            'click .img_holder': function() {
                var message = {
                    name: 'pixlee:scroll:mosaic:mobile',
                    type: 'action',
                    source: 'widget',
                    destination: 'parent',
                    data: {}
                };
                window.parent.postMessage(JSON.stringify(message), '*');
            }
        },
        changeImage: function() {
            var _this = this;
            var index = this.collection.indexOf(this.model);
            this.collection.remove(this.collection.at(index), {
                silent: true
            });


            var model = gon.fresh_images[0];
            model.collection = this.model.collection;
            this.collection.add(model, {
                at: index,
                silent: true
            });
            _this.model = model;
            _this.addView.model = this.model;


            gon.fresh_images.shift();

            this.$el.removeClass('starred');
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }

            var currentView = this.activeView ? this : this.addView;
            var inactive = !this.activeView ? this : this.addView;

            inactive.$el.removeClass('starred');
            if (inactive.model.get('is_starred')) {
                inactive.$el.addClass('starred');
            }

            inactive.render();

            var helpers = _this.templateHelpers;
            for (i in this.model.attributes) {
                helpers[i] = this.model.attributes[i];
            }
            var url = helpers.thumbnail.call(helpers);

            var image = new Image();

            image.src = url;

            image.onload = function() {
                inactive.$el.animate({
                    opacity: 1
                }, 1000, function() {
                    inactive.$el.css('z-index', '1');
                    inactive.activeView = true;
                });
                currentView.$el.animate({
                    opacity: 0
                }, 1000, function() {
                    currentView.activeView = false;
                    currentView.render();
                    currentView.$el.css('z-index', '0');
                });
            };

        },
        onShow: function() {
            // debugger;
            this.$el.wrap("<div class='photo_item_container'></div>");
            this.$el.css({
                'position': 'absolute',
                'top': '0px',
                'left': '0px'
            });
            this.activeView = true;
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                this.addView();
            }
        },
        addView: function() {
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                this.addView = new Show.PhotoView({
                    model: this.model
                });
                this.$el.after(this.addView.$el);
                this.$el.css('z-index', '1');
                this.addView.render();
                this.addView.$el.css({
                    'position': 'absolute',
                    'top': '0px',
                    'left': '0px',
                    'opacity': "0",
                    'z-index': "0"
                });
                this.addView.activeView = true;
            }
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    Show.MosaicCollection = App.Views.CollectionView.extend({
        childView: Show.PhotoView,
        className: 'clearfix',
        tagName: 'ul',
        behaviors: {
            CollectionVote: {},
            AppendUploaderTiles: {}
        },
        initialize: function() {
            gon.fresh_images = [];
        },
        onShow: function() {
            $('#widget').attr('alt', App.altText);
        },
        onAddChild: function(item) {
            item.collection = this.collection;
        },
        onRender: function() {
            var _this = this;
            var mosaicMinimum = gon.current_account.id === 1202 ? 9 : 16;
            if (this.collection.length > 0) {
                if (this.collection.length > mosaicMinimum) {
                    gon.fresh_images = this.collection.last(this.collection.length - mosaicMinimum);
                    this.collection.reset(this.collection.first(mosaicMinimum), {
                        silent: true
                    });
                }
                if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                    gon.currentLength = this.collection.length;
                    this.options.referenceCollection.next = this.collection.next;
                    this.options.referenceCollection.nextPage();
                    this.options.referenceCollection.on('sync', this.refreshReferenceCollection, this);
                }
            }
        },
        refreshReferenceCollection: function() {
            gon.currentLength += this.options.referenceCollection.length;
            this.options.referenceCollection.models.reverse();
            this.options.referenceCollection.each(function(model) {
                if (model.attributes && (model.attributes.source_url || model.attributes.data_file_name)) {
                    gon.fresh_images.push(model);
                }
            });
            this.setTimer();
        },
        showLoadMore: function() {
            this.$el.find('#mosaic_control').show();
        },
        hideLoadMore: function() {
            this.$el.find('#mosaic_control').hide();
        },
        setTimer: function() {
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                var _this = this;
                clearTimeout(gon.timer);
                if (gon.fresh_images.length === 0) {
                    this.options.referenceCollection.reset();
                    this.options.referenceCollection.models = [];
                    if (!_this.options.referenceCollection.next) {
                        gon.currentLength = 0;
                        // this.options.referenceCollection.goTo(1);
                        return false;
                    } else {
                        this.options.referenceCollection.nextPage();
                        return false;
                    }
                } else {
                    gon.timer = setTimeout(function() {
                        var elems = [];
                        _.each(_this.children._views, function(view) {
                            if (view.$el.is(':visible')) {
                                elems.push(view);
                            }
                        });
                        if (elems.length > 0 && gon.fresh_images[0] && gon.fresh_images[0].get('is_starred')) {
                            var random = Math.floor(Math.random() * Math.min(3, elems.length));
                            elems[random].trigger('change:image');
                        } else if (elems.length > 0) {
                            var random = Math.floor(Math.random() * Math.min(15, elems.length));
                            elems[random].trigger('change:image');
                        }
                        _this.setTimer();
                    }, 5000);
                }
            }
        }
    });
    Show.MosaicCollection.include(['designEditorCollectionHelpers', 'socialShareHelpers']);
    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });

    Show.HeaderView.include(['StandaloneHeaderHelpers']);

});